export const PRESTIGE = "💠";
export const MULTIPLIER = "💹";
export const COIN = "🪙";
export const BALANCE = "💰";
export const BRIEFCASE = "💼";
